import { useGSAP } from '@gsap/react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { useRef } from 'react';

gsap.registerPlugin(ScrollTrigger);

const Nophotocouple = ({ details }) => {
  const sectionRef = useRef(null);
    const topPatternRef = useRef(null);
    const cardRef = useRef(null);
    const bottomPatternRef = useRef(null);
  
  useGSAP(() => {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: sectionRef.current,
      start: "top 85%",
      once: true,
    },
  });

  // Top lace
  tl.from(
    topPatternRef.current,
    {
      opacity: 0,
      duration: 0.6,
      ease: "power2.out",
    },
    0
  );

  // Main card
  tl.from(
    cardRef.current,
    {
      opacity: 0,
      y: 20,
      duration: 0.8,
      ease: "power2.out",
    },
    0.1
  );

  // Bottom lace
  tl.from(
    bottomPatternRef.current,
    {
      opacity: 0,
      duration: 0.6,
      ease: "power2.out",
    },
    0.15
  );

}, {
  scope: sectionRef,
});

   const renderPersonCard = ({
    fullname,
    parentprefix,
    parentsName,
    grandParentsPrefix,
    grandParentsName,
  }) => {
    return (
      <div className="t4-single-couple-container" data-aos="fade-up">

        <div className="t4-couple-grandparents">
          {grandParentsName && (
  <p>
    {grandParentsPrefix} {grandParentsName}
  </p>
)}
        </div>

        <h1 className="t4-couple-name">
          {fullname}
        </h1>

        <div className="t4-couple-parents">
        {parentsName && (
  <p>
    {parentprefix} {parentsName}
  </p>
)}
        </div>

      </div>
    );
  };

  const groomCard = () =>
    renderPersonCard({
      fullname: details?.groomFullName || "Groom Full Name",
      parentprefix: details?.groomParentsPrefix,
      parentsName: details?.groomParents,
      grandParentsPrefix: details?.groomGrandParentsPrefix,
      grandParentsName: details?.groomGrandParents,
    });

  const brideCard = () =>
    renderPersonCard({
      fullname: details?.brideFullName || "Bride Full Name",
      parentprefix: details?.brideParentsPrefix,
      parentsName: details?.brideParents,
      grandParentsPrefix: details?.brideGrandParentsPrefix,
      grandParentsName: details?.brideGrandParents,
    });

    

  return (
    <section className="couple-section no-photo-couple theme4" ref={sectionRef} >
      <img
        src="/theme4-couple-section-decor.png"
        alt=""
        ref={topPatternRef}
        className="photo-couple-pattern photo-couple-pattern-top"
      />
      <div className="photo-couple-container"  ref={cardRef} >
        <div className="theme4-no-couple-content">
          <h1 className="t4-couple-heading" data-aos="fade-up">
            {details?.sectionHeading}
          </h1>
            <div className="t4-couple-wrapper">
          {details?.displayOrder === "groomFirst" ? (
                    <>
                      {groomCard()}
                          <span className="t4-couple-divider" data-aos="fade-up">
                        &
                    </span>
                    {brideCard()}
                    </>
                   ) : ( <>
                       {brideCard()}
                         <span className="t4-couple-divider" data-aos="fade-up">
                        &
                    </span>
                    {groomCard()}
                   </>) }
          {/* <span className="t4-couple-divider" >
                        &
                    </span> */}
           
          
        </div>
        </div>
      
      </div>
      <img
        src="/theme4-couple-section-decor.png"
           ref={bottomPatternRef}
        alt=""
        className="photo-couple-pattern photo-couple-pattern-bottom"
      />
    </section>
  )
}

export default Nophotocouple